module.exports = __webpack_public_path__ + "img/3fe0a4f.png";